// Module
var code = "<record-form-view fields=\"stateController.formFields\" model=\"stateController.progressiveDefinition\" title=\"{{stateController.getTitle()}}\" on-submit=\"stateController.submit(formViewController)\" on-cancel=\"stateController.cancel(formViewController)\"> </record-form-view> ";
// Exports
export default code;